export default "__VITE_ASSET__609d66af__"